import React, {Component} from "react";
import PropTypes from 'prop-types';
import {
  appInfoParameter
} from '../../config';
import {DisplayText, Button} from '@shopify/polaris';
import './style.scss';
import ListApp from '../ListApp';

class CrossSell extends Component {

  constructor(props) {
    super(props);

    function getVal(str) {
      let v = window.location.search.match(
        new RegExp('(?:[?&]' + str + '=)([^&]+)')
      );
      return v ? v[1] : undefined;
    }

    const shopDomain = getVal('shop');
    this.state = {
      shop: shopDomain,
      appModalOpen: true
    };
  }

  moreActionAppClick = app => {
    this.showAppInfoModal(app);
  };

  showAppInfoModal = app => {
    window.ShopifyApp.Modal.open(
      {
        src: `${appInfoParameter}?app-request=${app}`,
        title: 'Sales Pop Master',
        width: 'large',
        height: 700,
        buttons: {
          secondary: [
            {
              label: 'Close',
              callback: function (label) {
                window.ShopifyApp.Modal.close();
              }
            }
          ]
        }
      },
      function (result, data) {
        alert('result: ' + result + '   data: ' + data);
      }
    );
  };

  appCrossSellTrack = app => {
    window.mixpanel.track(`${this.props.appCode} cross sell footer to app: ${app}`);
  };

  render() {
    let listOrders = '';
    switch (this.props.appCode) {
      case 'sales-pop':
        listOrders = <div className="row">
          <ListApp appName="facebook-chat" shop={this.props.shop}/>
          <ListApp appName="currency" shop={this.props.shop}/>
          <ListApp appName="email-with-love" shop={this.props.shop}/>
        </div>;
        break;
      case 'facebook-chat':
        listOrders = <div className="row">
          <ListApp appName="currency" shop={this.props.shop}/>
          <ListApp appName="sales-pop" shop={this.props.shop}/>
          <ListApp appName="discount-master" shop={this.props.shop}/>
        </div>;
        break;
      case 'currency-convert':
        listOrders = <div className="row">
          <ListApp appName="facebook-chat" shop={this.props.shop}/>
          <ListApp appName="sales-pop" shop={this.props.shop}/>
          <ListApp appName="email-with-love" shop={this.props.shop}/>
        </div>;
        break;
      case 'email-with-love':
        listOrders = <div className="row">
          <ListApp appName="facebook-chat" shop={this.props.shop}/>
          <ListApp appName="currency" shop={this.props.shop}/>
          <ListApp appName="sales-pop" shop={this.props.shop}/>
        </div>;
        break;
    }

    return (
      <div className="mt-5">
        <div className="mt-5">
          <DisplayText size="medium">Get more apps</DisplayText>
          <hr/>
          <div id="wrap-app-recommendation" className="mt-5">
            {listOrders}
          </div>
        </div>
      </div>
    )
  }
}

CrossSell.propTypes = {
  appCode: PropTypes.string.isRequired,
  shop: PropTypes.string.isRequired
};

export default CrossSell;
